import { wrapper, getWrapper } from '../request';
export var getStyle = getWrapper('styles')('getStyle');
export var saveStyle = wrapper('styles')('saveStyle');
export var listStyle = getWrapper('styles')('listStyle');
export var resetStyle = wrapper('styles')('resetStyle');
export var listDiffStyles = getWrapper('styles')('listDiffStyles');